import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  link: {
    cursor: "pointer",
    textDecoration: "underline",
    color: theme.palette.primary.main,
  },
}));
